<template>
  <b-form>
    <b-card>
      <b-card-text>
        <b-row>
          <b-col
            sm="12"
            md="6"
          ><h6 class="mb-1">
            Özel Şartlar Şablonu Güncelle
          </h6></b-col>
        </b-row>
        <b-form-group label="Başlık">
          <b-form-input
            v-model="formData.title"
            placeholder="Başlık"
          />
        </b-form-group>
        <b-form-group label="Özel Şartlar">
          <quill-editor
            v-model="formData.content"
            :options="editorOption"
            class="bg-white text-black-50"
          >
            <div
              id="toolbar"
              slot="toolbar"
            >
              <!-- Add a bold button -->
              <button class="ql-bold">
                Bold
              </button>
              <button class="ql-italic">
                Italic
              </button>
              <button
                class="ql-list"
                value="ordered"
              />
              <!-- Add font size dropdown -->
              <select class="ql-size">
                <option value="small" />
                <!-- Note a missing, thus falsy value, is used to reset to default -->
                <option selected />
                <option value="large" />
                <option value="huge" />
              </select>
              <select class="ql-font">
                <option selected="selected" />
                <option value="serif" />
                <option value="monospace" />
              </select>
              <!-- Add subscript and superscript buttons -->
              <button
                class="ql-script"
                value="sub"
              />
              <button
                class="ql-script"
                value="super"
              />
            </div>
          </quill-editor>
        </b-form-group>
      </b-card-text>
    </b-card>
    <b-button
      variant="danger"
      :disabled="submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </b-form>
</template>

<script>
import {
  BForm,
  BCard,
  BCardText,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
// eslint-disable-next-line import/order
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'OfferTermsEdit',
  components: {
    BForm,
    BCard,
    BCardText,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    quillEditor,
  },
  data() {
    return {
      detailForm: false,
      submitStatus: false,
      formData: {
        title: null,
        content: null,
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
        theme: 'snow',
      },
    }
  },
  computed: {
    offer_termData() {
      return this.$store.getters['offerTerms/getOffer_term']
    },
    saveStatus() {
      const status = this.$store.getters['offerTerms/getOffer_termSaveStatus']
      return status
    },
  },
  watch: {
    offer_termData(val) {
      this.setFormData(val)
    },
    saveStatus(val) {
      if (val.status === true) {
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {
    this.getOffer_term()
  },
  methods: {
    getOffer_term() {
      this.$store.dispatch('offerTerms/offer_termView', this.$route.params.id)
    },
    setFormData(data) {
      this.formData = data
    },
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('offerTerms/offer_termSave', this.formData)
    },
  },
}
</script>
